var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstrumentsSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4275,
    cy: 50.0005,
    rx: 49.9653,
    ry: 50,
    fill: "#E5E5E5",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.1446 26.0005H56.6845C53.154 26.0005 50.2355 29.0436 49.6835 32.5137C49.5807 33.1591 50.1189 33.6922 50.7719 33.6922H61.4145C62.3842 33.6922 63.1883 34.4968 63.1883 35.4672C63.1883 36.4375 62.3842 37.2422 61.4145 37.2422H50.7719C50.1189 37.2422 49.5894 37.772 49.5894 38.4255V41.9755C49.5894 42.629 50.1189 43.1588 50.7719 43.1588H56.2351C57.2048 43.1588 58.0089 43.9635 58.0089 44.9338C58.0089 45.9042 57.2048 46.7088 56.2351 46.7088H50.7719C50.1189 46.7088 49.5894 47.2387 49.5894 47.8922V51.3357C49.5894 51.9846 50.1116 52.5124 50.7601 52.5188L61.4145 52.6255C62.4079 52.6255 63.1883 53.4302 63.1883 54.4242C63.1647 55.3945 62.3842 56.1755 61.4145 56.1755C61.3909 56.1755 61.3909 56.1755 61.3909 56.1755L50.7838 56.0693C50.126 56.0626 49.5894 56.5942 49.5894 57.2523V60.9089C49.5894 61.5623 50.1189 62.0922 50.7719 62.0922H58.813C59.8063 62.0922 60.5868 62.8969 60.5868 63.8672C60.5868 64.8375 59.8063 65.6422 58.813 65.6422H50.7719C50.1189 65.6422 49.5807 66.1754 49.6835 66.8208C50.2355 70.2908 53.154 73.3339 56.6845 73.3339H66.1446C70.0469 73.3339 73.2397 70.1625 73.2397 66.2339V33.1005C73.2397 29.1718 70.0469 26.0005 66.1446 26.0005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4201 32.9822V34.8755C42.4201 35.529 41.8907 36.0588 41.2376 36.0588H29.6253C28.9722 36.0588 28.4428 35.529 28.4428 34.8755V32.9822C28.4428 29.1482 31.5883 26.0005 35.4433 26.0005C39.2746 26.0005 42.4201 29.1482 42.4201 32.9822Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4428 63.6542C28.4428 64.7192 28.8922 66.3522 29.4598 67.2516L31.3754 70.4702C33.6222 74.2096 37.2644 74.2096 39.4875 70.4702L41.4268 67.2516C41.9708 66.3522 42.4201 64.7192 42.4201 63.6542V40.7922C42.4201 40.1387 41.8907 39.6089 41.2376 39.6089H29.6253C28.9722 39.6089 28.4428 40.1387 28.4428 40.7922V63.6542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrumentsSvg);
export default __webpack_public_path__ + "static/media/instruments-svg.e1fd5eede660c99d4c7eb8eb13a5ce0c.svg";
export { ForwardRef as ReactComponent };